/**
 * Build falhub://profile/{username} for opening the native app from the marketing site.
 */
export function buildProfileAppDeepLink(username) {
  if (username === null || username === undefined) return null;
  const value = String(username).trim();
  if (!value) return null;
  const lowered = value.toLowerCase();
  if (lowered === "null" || lowered === "undefined") return null;
  return `falhub://profile/${encodeURIComponent(value)}`;
}

/**
 * Attempt to hand off to the Fal Hub app (custom URL scheme).
 * Safe to call from WhatsApp / in-app browsers; no-op when the app is missing.
 */
export function tryOpenProfileInApp(username) {
  const deeplink = buildProfileAppDeepLink(username);
  if (!deeplink || typeof window === "undefined") return false;
  try {
    window.location.href = deeplink;
    return true;
  } catch (_) {
    return false;
  }
}

export function isLikelyMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  return /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent || ""
  );
}
